import { useState } from 'react';
import useFeature from 'services/features/useFeature';
import { useAnalytics } from '../../contexts/analytics/AnalyticsProvider';
import { useTinyAIContext } from './TinyAIContext';
import { TinyAIChatWindow } from './TinyAIChatWindow';
import { TinyAICloseButton } from './TinyAICloseButton';
import { TinyAIFloatingButton } from './TinyAIFloatingButton';

interface TinyAIProps {
  scrollableElRef?: React.RefObject<HTMLElement>;
}

export const TinyAI = ({ scrollableElRef }: TinyAIProps) => {
  const { isChatOpen, openChat, closeChat } = useTinyAIContext();
  const [isKeyboardVisible, setIsKeyboardVisible] = useState(false);
  const { isFeatureEnabled } = useFeature('tiny_ai_chatbot_in_results_portal');
  const { trackEvent } = useAnalytics();

  if (!isFeatureEnabled) {
    return null;
  }

  const handleOpen = () => {
    openChat();
    trackEvent('TinyAI widget opened');
  };

  const handleClose = () => {
    closeChat();
    trackEvent('TinyAI widget closed');
  };

  const handleKeyboardVisibilityChange = (isVisible: boolean) => {
    setIsKeyboardVisible(isVisible);
  };

  return (
    <div>
      {!isChatOpen ? (
        <TinyAIFloatingButton
          onClick={handleOpen}
          scrollableElRef={scrollableElRef}
        />
      ) : (
        <>
          <TinyAIChatWindow
            onKeyboardVisibilityChange={handleKeyboardVisibilityChange}
            scrollContainerRef={scrollableElRef}
          />
          <TinyAICloseButton
            onClick={handleClose}
            isKeyboardVisible={isKeyboardVisible}
          />
        </>
      )}
    </div>
  );
};
